export const getMarketById = (id, markets) =>
	markets?.find((market) => market._id === id);
